const Config = {
  tokenStorage: {},
  cookieName: 'CHEGGUSERTOKEN',
  accessTokenCookie: 'CHEGGUSERACCESSTOKEN',
  init(config) {
    Object.assign(this, config)
  },
  reset(key = 'accessToken', storage = localStorage) {
    storage.removeItem(key)
    storage.removeItem('refreshToken')
    this.tokenStorage.setToken(null)
  },
  getToken(key = 'accessToken') {
    return localStorage.getItem(key)
  },
  refreshToken() {
    const error = { status: 403, message: 'cannot refresh chegg token' }
    throw error
  },
  setTokenStorage(tokenStorage) {
    this.tokenStorage = tokenStorage
  },
  setToken(token) {
    localStorage.setItem('accessToken', token)
    localStorage.setItem('refreshToken', token)
    this.tokenStorage.setToken(token)
  },
  setWptAppUrl(url) {
    this.wptAppUrl = url
  },
  getOnUploadSuccess() {
    return this.onUploadSuccess
  },
  setOnUploadSuccess(func) {
    this.onUploadSuccess = func
  },
  getOnCfeAuthUpdate() {
    return this.onCfeAUthUpdate
  },
  setOnCfeAuthUpdate(func) {
    this.onCfeAUthUpdate = func
  },
  getcfeAuth() {
    return this.cfeAuth
  },
  setcfeAuth() {
    this.cfeAuth = true
  },
  getCfeApiUrl() {
    return this.cfeApiUrl
  },
  setCfeApiUrl(url) {
    this.cfeApiUrl = url
  },
}

export default Config
